const PASSWORD_REQUIREMENTS = [
  { test: /.{8,}/, message: 'At least 8 characters' },
  { test: /[a-z]/, message: 'One lowercase letter' },
  { test: /[A-Z]/, message: 'One uppercase letter' },
  { test: /\d/, message: 'One number' },
  { test: /[@$!%*?&]/, message: 'One special character (@$!%*?&)' },
]

export const getPasswordValidationErrors = (password: string) =>
  PASSWORD_REQUIREMENTS
    .filter((requirement) => !requirement.test.test(password))
    .map((requirement) => requirement.message)
